import React, { useState } from "react";
import { Row, Col, Button, Input, Drawer, Form } from "antd";
import Close from "../../../../assets/images/close-x.svg";
import CancelArrow from "../../../../assets/images/cancelArrow.svg";
import data from "../../../../constants/retailPos.json";

const GiftCardValidateDrawer = ({
  validateGiftCard,
  setValidateGiftCard,
  validateGiftCardForm,
  handleGiftCardDetails,
  giftCardType,
  setSearchTerm,
  setIsGiftCardFlag,
  setGiftCardBalance,
  giftCardBalance,
  setInputFocused,
  inputFocused,
  selectGiftCardItem,
  cart,
  handleAddGiftCardAmount,
  giftCardBalanceAmount,
  errorMessage,
  currenciesList,
  width,
}) => {
  const [gcvSubmitting, setGcvSubmitting] = useState(false);
  const [checkingBalance, setCheckingBalance] = useState(false);

  const handleGiftCardDetailsGuarded = async (values) => {
    if (gcvSubmitting) return;
    setGcvSubmitting(true);
    try {
      await handleGiftCardDetails(values);
    } finally {
      setGcvSubmitting(false);
    }
  };

  const giftCardBalanceAmountGuarded = async () => {
    if (checkingBalance) return;
    setCheckingBalance(true);
    try {
      await giftCardBalanceAmount();
    } finally {
      setCheckingBalance(false);
    }
  };

  return (
    <Drawer
      closable={true}
      placement="bottom"
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "2vh",
            fontSize: "1vw",
          }}
        >
          <p
            style={{
              fontSize: "1.5em",
              marginTop: "3vh",
              fontWeight: "500",
              color: "#0F0718",
              flex: 1,
              textAlign: "center",
            }}
          >
            New {giftCardType}
          </p>
          <img
            src={Close}
            onClick={() => {
              validateGiftCardForm.resetFields();
              setValidateGiftCard(false);
              setSearchTerm("");
              setIsGiftCardFlag(false);
              setGiftCardBalance("0.00");
            }}
            // style={{ marginLeft: "auto", paddingBottom: "4vh", cursor: "pointer" }}
            style={{
              marginLeft: "auto",
              paddingBottom: "4vh",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      open={validateGiftCard}
      className="filter"
      styles={{ body: { paddingBottom: 0, paddingTop: 0 } }}
      onClose={() => {
        validateGiftCardForm.resetFields();
        setValidateGiftCard(false);
        setGiftCardBalance("0.00");
      }}
      //  id="sm-drawer-close
      height="77vh"
    >
      <Form layout="vertical" form={validateGiftCardForm} onFinish={handleGiftCardDetailsGuarded}>
        <Row>
          <Col span={11} offset={1} style={{ paddingRight: "1vw" }}>
            <Row>
              <Col span={20} pull={2} push={2} style={{ fontSize: "1vw" }}>
                <Form.Item
                  style={{ marginBottom: "10px", fontSize: "1vw" }}
                  name="number"
                  label={
                    <div style={{ fontSize: "1vw" }}>
                      <span
                        style={{
                          color: "#0F0718",
                          fontSize: "1.25em",
                          fontWeight: "500",
                        }}
                      >
                        {giftCardType} Number
                      </span>
                    </div>
                  }
                >
                  <Input
                    id="issueCardInput"
                    placeholder={`Enter Number`}
                    onFocus={() => {
                      setInputFocused("issueGiftCardNumber");
                    }}
                    onPressEnter={(e) => {
                      e.preventDefault();
                    }}
                    disabled={Object.keys(selectGiftCardItem).length > 0 && selectGiftCardItem?.type === "PHY" ? false : true}
                    size="large"
                    allowClear={false}
                    style={{
                      ...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput,
                      padding: "2vh 1.5vw",
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} pull={2} push={2} style={{ paddingTop: "1vh" }}>
                <Form.Item
                  style={{ marginBottom: "10px", fontSize: "1vw" }}
                  name="cardPin"
                  label={
                    <div style={{ fontSize: "1vw" }}>
                      <span
                        style={{
                          color: "#0F0718",
                          fontSize: "1.25em",
                          fontWeight: "500",
                        }}
                      >
                        PIN
                      </span>
                    </div>
                  }
                >
                  <Input
                    id="cardPin"
                    onFocus={() => {
                      setInputFocused("cardPin");
                    }}
                    placeholder={`Enter Pin`}
                    size="large"
                    onPressEnter={(e) => {
                      e.preventDefault();
                    }}
                    allowClear={false}
                    style={{
                      ...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput,
                      padding: "2vh 1vw",
                      width: "200px",
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={9} push={3} style={{ paddingTop: "1vh" }}>
                <Form.Item
                  style={{
                    marginBottom: "",
                    marginTop: "5px",
                    marginLeft: "30px",
                    fontSize: "1vw",
                  }}
                  name="amount"
                  label={
                    <div style={{ fontSize: "1vw" }}>
                      <span
                        style={{
                          color: "#0F0718",
                          fontSize: "1.25em",
                          fontWeight: "500",
                          marginBottom: "10px",
                          marginLeft: "10px",
                        }}
                      >
                        {giftCardType} Balance
                      </span>
                    </div>
                  }
                >
                  <span
                    style={{
                      fontSize: "2.5em",
                      fontWeight: 500,
                      lineHeight: "2rem",
                      marginLeft: "10px",
                    }}
                  >
                    {parseFloat(giftCardBalance).toFixed(2)}
                  </span>
                </Form.Item>
              </Col>

              <Col span={8} pull={2} push={2} style={{ paddingTop: "1vh" }}>
                <Form.Item
                  style={{ marginBottom: "10px", fontSize: "1vw" }}
                  name="amount"
                  initialValue={cart.isReturn ? Math.abs(cart.total) : selectGiftCardItem.variableAmount === "Y" ? "" : selectGiftCardItem.initialAmount}
                  label={
                    <div style={{ fontSize: "1vw" }}>
                      <span
                        style={{
                          color: "#0F0718",
                          fontSize: "1.25em",
                          fontWeight: "500",
                        }}
                      >
                        Amount
                      </span>
                    </div>
                  }
                >
                  <Input
                    id="issueCardAmount"
                    placeholder="Enter Amount"
                    onFocus={() => {
                      setInputFocused("issueAmount");
                    }}
                    size="large"
                    allowClear={false}
                    onPressEnter={(e) => {
                      e.preventDefault();
                    }}
                    disabled={selectGiftCardItem.variableAmount === "Y" ? false : true}
                    style={{
                      ...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput,
                      padding: "2vh 1.5vw",
                      width: "200px",
                    }}
                  />
                </Form.Item>
              </Col>

              <Col span={8} offset={3} pull={2} push={2} style={{ padding: "1% 0", fontSize: "1vw" }}>
                <Button
                  style={{
                    backgroundColor: "#046307C2",
                    color: "#fff",
                    width: "100%",
                    fontSize: "1.25em",
                    textAlign: "center",
                    fontWeight: "500",
                    borderRadius: "5px",
                    height: "8vh",
                    width: "150px",
                    marginTop: "32px",
                  }}
                  disabled={checkingBalance}
                  loading={checkingBalance}
                  onClick={(e) => {
                    if (navigator.onLine) {
                      giftCardBalanceAmountGuarded();
                    } else {
                      errorMessage("Sync Failed", "Please check your network connection and try again");
                    }
                  }}
                >
                  Check Balance
                </Button>
              </Col>
            </Row>

            <Row>
              <Col span={20} pull={2} push={2} style={{ paddingTop: "2vh" }}>
                <Row gutter={[16, 16]} style={{ fontSize: "1vw" }}>
                  <Col span={8}>
                    <p
                      onClick={() => handleAddGiftCardAmount("200")}
                      style={{
                        textAlign: "center",
                        backgroundColor: "#fff",
                        padding: "1vh 0",
                        border: "1px solid rgba(146, 144, 152, 0.5)",
                        borderRadius: "4px",
                        fontSize: "1em",
                        fontWeight: 400,
                        color: "#0F0718",
                      }}
                    >
                      {currenciesList[0].currSymbol}200
                    </p>
                  </Col>
                  <Col span={8}>
                    <p
                      onClick={() => handleAddGiftCardAmount("500")}
                      style={{
                        textAlign: "center",
                        backgroundColor: "#fff",
                        padding: "1vh 0",
                        border: "1px solid rgba(146, 144, 152, 0.5)",
                        borderRadius: "4px",
                        fontSize: "1em",
                        fontWeight: 400,
                        color: "#0F0718",
                      }}
                    >
                      {currenciesList[0].currSymbol}500
                    </p>
                  </Col>
                  <Col span={8}>
                    <p
                      onClick={() => handleAddGiftCardAmount("1000")}
                      style={{
                        textAlign: "center",
                        backgroundColor: "#fff",
                        padding: "1vh 0",
                        border: "1px solid rgba(146, 144, 152, 0.5)",
                        borderRadius: "4px",
                        fontSize: "1em",
                        fontWeight: 400,
                        color: "#0F0718",
                      }}
                    >
                      {currenciesList[0].currSymbol}1000
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={11} offset={1} style={{ padding: "" }}>
            <Row style={{ padding: "0% 1% 0 3.5%" }} gutter={[8, 6]}>
              {/* <Col span={20} pull={2} push={2} style={{ padding: "" }}>
                <Form.Item style={{ marginBottom: "10px" }} name="amount" label={
                  <span style={{ color: "#000", fontSize: "1.2vw", fontWeight: "500" }}>
                    Enter Amount
                  </span>
                }>
                  <Input
                   id ="issueCardAmount"
                   onFocus={()=>{setInputFocused("issueAmount")}}
                    // placeholder={`Type to add a note`}
                    size="large"
                    allowClear={false}
                    style={{...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput,padding:"2.5vh 0"}}
                  />
                </Form.Item>
              </Col> */}
              <Row style={{ padding: "0 8%", fontSize: "1vw" }} gutter={[8, 6]}>
                <Col span={6}>
                  <button
                    id="sm-amount-button1"
                    className="amt-dial-btn-gift1"
                    onClick={(e) => {
                      handleAddGiftCardAmount("1");
                      e.preventDefault();
                    }}
                  >
                    1
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    id="sm-amount-button2"
                    className="amt-dial-btn-gift1"
                    onClick={(e) => {
                      handleAddGiftCardAmount("2");
                      e.preventDefault();
                    }}
                  >
                    2
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    id="sm-amount-button3"
                    className="amt-dial-btn-gift1"
                    onClick={(e) => {
                      handleAddGiftCardAmount("3");
                      e.preventDefault();
                    }}
                  >
                    3
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    className="amt-dial-btn-gift1"
                    id="sm-amount-buttonRemove"
                    onClick={(e) => {
                      handleAddGiftCardAmount("x");
                      e.preventDefault();
                    }}
                  >
                    <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 25} height={width <= 1024 ? 15 : 15} />
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    id="sm-amount-button4"
                    className="amt-dial-btn-gift1"
                    onClick={(e) => {
                      handleAddGiftCardAmount("4");
                      e.preventDefault();
                    }}
                  >
                    4
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    id="sm-amount-button5"
                    className="amt-dial-btn-gift1"
                    onClick={(e) => {
                      handleAddGiftCardAmount("5");
                      e.preventDefault();
                    }}
                  >
                    5
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    id="sm-amount-button6"
                    className="amt-dial-btn-gift1"
                    onClick={(e) => {
                      handleAddGiftCardAmount("6");
                      e.preventDefault();
                    }}
                  >
                    6
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    onClick={(e) => {
                      handleAddGiftCardAmount("clear");
                      e.preventDefault();
                    }}
                    id="sm-amount-addQuantity"
                    className="amt-dial-btn-gift1"
                  >
                    Clear
                  </button>
                </Col>
                <Col span={18}>
                  <Row gutter={[8, 6]}>
                    <Col span={8}>
                      <button
                        id="sm-amount-button7"
                        className="amt-dial-btn-gift1"
                        onClick={(e) => {
                          handleAddGiftCardAmount("7");
                          e.preventDefault();
                        }}
                      >
                        7
                      </button>
                    </Col>
                    <Col span={8}>
                      <button
                        id="sm-amount-button8"
                        className="amt-dial-btn-gift1"
                        onClick={(e) => {
                          handleAddGiftCardAmount("8");
                          e.preventDefault();
                        }}
                      >
                        8
                      </button>
                    </Col>
                    <Col span={8}>
                      <button
                        id="sm-amount-button0"
                        className="amt-dial-btn-gift1"
                        onClick={(e) => {
                          handleAddGiftCardAmount("9");
                          e.preventDefault();
                        }}
                      >
                        9
                      </button>
                    </Col>
                    <Col span={8}>
                      <button
                        id="sm-amount-button0"
                        className="amt-dial-btn-gift1"
                        onClick={(e) => {
                          handleAddGiftCardAmount("0");
                          e.preventDefault();
                        }}
                      >
                        0
                      </button>
                    </Col>
                    <Col span={8}>
                      <button
                        id="sm-amount-button00"
                        className="amt-dial-btn-gift1"
                        onClick={(e) => {
                          handleAddGiftCardAmount(".");
                          e.preventDefault();
                        }}
                      >
                        .
                      </button>
                    </Col>
                    <Col span={8}>
                      <button
                        id="sm-amount-button."
                        className="amt-dial-btn-gift1"
                        onClick={(e) => {
                          handleAddGiftCardAmount("00");
                          e.preventDefault();
                        }}
                      >
                        00
                      </button>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <button id="sm-amount-buttonEnter" className="amt-dial-btn-gift12">
                    Enter
                  </button>
                </Col>
              </Row>
              <Col span={20} pull={2} push={2} style={{ padding: "3% 0", fontSize: "1vw" }}>
                <Button
                  htmlType="submit"
                  disabled={gcvSubmitting}
                  loading={gcvSubmitting}
                  style={{
                    backgroundColor: "#2F3856",
                    color: "#fff",
                    width: "100%",
                    fontSize: "1.5em",
                    textAlign: "center",
                    fontWeight: "500",
                    borderRadius: "7px",
                    height: "8vh",
                  }}
                >
                  Issue
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
};

export default GiftCardValidateDrawer;
